import cogoToast from 'cogo-toast';
import { confirmAlert } from 'react-confirm-alert';
import React, { useContext, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import {
  Button,
  Card,
  CardBody,
  Col,
  CustomInput,
  Input,
  Row,
} from 'reactstrap';
import DetailRow from '../../../components/GestionPersonaEmpresa/personDetails/DetailRow';
import FalconCardHeader from '../../../components/common/FalconCardHeader';
import { urlApi } from '../../../configuracion/serverConfig';
import { authSesion, headers } from '../../../helpers/authSesion';
import { currencyFormat, percentageFormat } from '../../../helpers/tableFormatters';
import { StateContext } from '../StateContext';

const TIPO_FORMULA_OPTIONS = [
  { value: 1, label: 'Amortizable' },
  { value: 2, label: 'Fija' },
];

const GeneralConditionsInfo = ({ onPreview }) => {
  const context = useContext(StateContext);
  const { loading, creditSelected: selected } = context;

  const sesion = JSON.parse(sessionStorage.getItem('Usuario'));
  const isAdmin = sesion && sesion.perfil == 1;

  const [editMode, setEditMode] = useState(false);
  const [saving, setSaving] = useState(false);
  const [tipoFormula, setTipoFormula] = useState(1);
  const [tasa, setTasa] = useState('');

  useEffect(() => {
    if (selected) {
      setTipoFormula(selected.tipoFormula || 1);
      setTasa(selected.tasa || '');
    }
    setEditMode(false);
  }, [selected]);

  const handleCancel = () => {
    setTipoFormula(selected.tipoFormula || 1);
    setTasa(selected.tasa || '');
    setEditMode(false);
  };

  const handleSave = () => {
    if (document.styleSheets[0].cssRules[0].selectorText !== '.react-confirm-alert-overlay') {
      document.styleSheets[0].insertRule('.react-confirm-alert-overlay { z-index: 9999 !important; }', 0);
    }
    confirmAlert({
      title: 'Confirmar cambios',
      message: '¿Confirma actualizar la tasa y/o tipo de fórmula del crédito?',
      buttons: [
        {
          label: 'Sí',
          onClick: async () => {
            setSaving(true);
            try {
              const params = new URLSearchParams({ tipoFormula, tasa }).toString();
              const resp = await fetch(
                `${urlApi}/prestamo/${authSesion()}/${selected.prestamo}?${params}`,
                { method: 'PATCH', headers }
              ).then(r => r.json());

              if (resp.status === 0) {
                cogoToast.success('Condiciones actualizadas', { position: 'bottom-right' });
                setEditMode(false);
              } else {
                cogoToast.error(resp.objError?.msgError || 'Error al guardar', { position: 'bottom-right' });
              }
            } catch (e) {
              cogoToast.error('Error al guardar', { position: 'bottom-right' });
            } finally {
              setSaving(false);
            }
          },
        },
        { label: 'No' },
      ],
    });
  };

  return (
    <Card className={`my-3`}>
      <FalconCardHeader title="Condiciones Generales"></FalconCardHeader>
      <CardBody className="bg-light border-top px-4">
        {!loading && selected ? (
          <Row className="text-right fs-3">
            <Col lg={12}>
              <DetailRow className="pb-3" textNormal title="Monto del Crédito">
                {selected.monto ? currencyFormat(selected.monto) : <span className='p-2'></span>}
              </DetailRow>
              <Row className="ml-3 justify-content-between pb-0">
                <Col lg={5} className='d-flex flex-column p-0'>
                  <div className='fs--2 text-left'>Tipo fórmula</div>
                  {editMode ? (
                    <CustomInput
                      type="select"
                      id="tipoFormula"
                      name="tipoFormula"
                      value={tipoFormula}
                      onChange={e => setTipoFormula(Number(e.target.value))}
                      bsSize="sm"
                    >
                      {TIPO_FORMULA_OPTIONS.map(opt => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))}
                    </CustomInput>
                  ) : (
                    <div className='text-left' style={{ fontSize: '1.2rem' }}>
                      {selected.nomTipoFormula || <span className='p-2'></span>}
                    </div>
                  )}
                </Col>
                <Col lg={7} className='d-flex flex-column p-0'>
                  <div className='fs--2'>Tasa de Interés</div>
                  {editMode ? (
                    <Input
                      type="number"
                      id="tasa"
                      name="tasa"
                      value={tasa}
                      onChange={e => setTasa(e.target.value)}
                      step="0.01"
                      min="0"
                      bsSize="sm"
                    />
                  ) : (
                    <div>
                      {selected.tasa ? percentageFormat(selected.tasa) : <span className='p-2'></span>}
                    </div>
                  )}
                </Col>
              </Row>
              <Row className="ml-3 justify-content-between pb-0">
                <Col lg={5} className='d-flex flex-column p-0'>
                  <div className='fs--2 text-left'>Plazo</div>
                  <div className='text-left'>
                    {selected.plazo || <span className='p-2'></span>}
                  </div>
                </Col>
                <Col lg={7} className='d-flex flex-column p-0'>
                  <div className='fs--2'>Valor Cuota</div>
                  <div>
                    <CountUp end={selected.valorCuota || 0} duration={1} prefix="$" separator="." decimal="," decimals={2} />
                  </div>
                </Col>
              </Row>
              <Row className="mt-3 justify-content-end mr-0">
                {!editMode ? (
                  isAdmin && (
                    <Button color="primary" size="sm" onClick={() => setEditMode(true)}>
                      Cambiar tasa y/o interés
                    </Button>
                  )
                ) : (
                  <>
                    <Button color="secondary" size="sm" className="mr-2" onClick={handleCancel}>
                      Cancelar
                    </Button>
                    <Button color="info" size="sm" className="mr-2" onClick={() => onPreview && onPreview({ tipoFormula, tasa })}>
                      Previsualizar
                    </Button>
                    <Button color="success" size="sm" onClick={handleSave} disabled={saving}>
                      Guardar
                    </Button>
                  </>
                )}
              </Row>
            </Col>
          </Row>
        ) : <></>}
      </CardBody>
    </Card>
  );
};

export default GeneralConditionsInfo;
